import { ApplicationLog } from '@organization/api/requests'
import { MenuProps } from 'antd'
import { TFunction } from 'i18next'
import { Eye } from 'iconsax-react'

import { LogApplicationsActionsTypes } from '../LogActions'

const iconProps = {
  size: 16
}

export const getApplicationsActionColumnMenu =
  (
    onClick: (
      modal: {
        type: LogApplicationsActionsTypes
        data: ApplicationLog
      } | null
    ) => void,
    t: TFunction
  ) =>
  (data: ApplicationLog): MenuProps['items'] => {
    return [
      {
        label: t('details'),
        key: 'preview',
        icon: <Eye {...iconProps} />,
        onClick: () => onClick({ data, type: 'preview' })
      }
    ]
  }
